export default __webpack_public_path__ + "static/media/frerecodeur.121ac65f.webp";